import type { PendingSale, WorkshopPendingSales } from '../../../../api/rebooking';
import { SimpleModal } from '../../../shared/SimpleModal';

export interface CancelBlockedDialogProps {
  pending: WorkshopPendingSales;
  onClose: () => void;
}

function saleLabel(sale: PendingSale): string {
  const who = sale.customerName?.trim() || 'Unnamed customer';
  return `${who} · ${sale.ticketCount} ticket${sale.ticketCount === 1 ? '' : 's'}`;
}

/** Shown instead of the picker while a sale on the workshop has not settled. */
export function CancelBlockedDialog({ pending, onClose }: CancelBlockedDialogProps) {
  const sections = [
    {
      title: 'Reservations holding seats',
      hint: 'Release them from the Reservations tab, then re-create them on another workshop.',
      sales: pending.liveReservations,
    },
    {
      title: 'Payments in progress',
      hint: 'Wait for these to finish; a completed payment becomes a booking that moves with the rest.',
      sales: pending.paymentsInFlight,
    },
  ].filter((section) => section.sales.length > 0);

  return (
    <SimpleModal
      open
      onClose={onClose}
      title="This workshop can’t be cancelled yet"
      footer={
        <button type="button" className="nb-btn" onClick={onClose}>
          OK
        </button>
      }
    >
      <p style={{ margin: 0, fontSize: 13, lineHeight: 1.5 }}>
        Some sales on this workshop haven’t settled. Once they’re cleared, try again.
      </p>
      {sections.map((section) => (
        <div key={section.title} style={{ marginTop: 12 }}>
          <div style={{ fontWeight: 600, fontSize: 13 }}>{section.title}</div>
          <div style={{ fontSize: 12, color: 'var(--nb-subtle)', marginBottom: 4 }}>
            {section.hint}
          </div>
          <ul style={{ margin: 0, paddingLeft: 18, fontSize: 13 }}>
            {section.sales.map((sale) => (
              <li key={sale.id}>{saleLabel(sale)}</li>
            ))}
          </ul>
        </div>
      ))}
    </SimpleModal>
  );
}
